import jQuery from 'jquery';
let $ = jQuery;

import "LIBS/clamp.js";
import "LIBS/jquery.slimscroll.js";
import "LIBS/jquery.equalHeights.js";
import "LIBS/jquery.placeholder.js";
import "LIBS/jquery.onviewed.js";
import "LIBS/browser-deeplink.js";
import "LIBS/jquery.unobtrusive-ajax.js";

// Global
import "./HSN/Modal.js";
import "./HSN/OffCanvas.js";
import "HSNDIR/BuySelector.js";
import "HSNDIR/AccountNavigation.js";
import "./HSN/CoremetricsPatch.js";

import "HSN";
import "./HSN/Application.js";
import "./HSN/EmailSignUp.js";
import "./HSN/Flyout.js";
import "./HSN/FlyoutManager.js";
import "./HSN/HamburgerFlyout.js";
import "./HSN/BagFlyout.js";

import "./HSN/AccountNavigation/AccountMenu.js";
import "./HSN/AccountNavigation/Cabinet.js";
import "./HSN/AccountNavigation/Cabinet/Drawer.js";

import "./HSN/ResponsiveCells.js";
import "./HSN/DataLayer.js";
import "./HSN/TodaysSpecial.js";
import YoutubePlayer from 'HSNDIR/Widget/VideoPlayers/YoutubePlayer.js';
import accessibilityUtil from 'HSNDIR/AccessibilityUtility.js';
import "HSNDIR/BuyAgain.js";
import "HSNDIR/DynamicCarouselHelper.js";

// Passed to HSN.Application
import "./HSN/NicknameModal.js";
import "./HSN/VideoModal.js";
import './HSN/Widget/FancyInput.js';
import "HSNDIR/Widget/WriteReview.js";
import Events from "./HSN/Events.js";

/*
The purpose of the Initializer is to create a new instance of the HSN.Application
and give it to the HSN singleton interface.
    
By separating the Application from the initialization it allows us to provide it
the dependencies it needs without having to be aware of the HTML layer providing
us far more flexibility to change the markup in the future.
*/

var noAjax = jQuery('input#header-noajax').length > 0 ? jQuery('input#header-noajax').val() : false;
var flyouts = typeof(HsnArcadeObjectName) != 'undefined' && HsnArcadeObjectName.length > 0 ? [] : BuildFlyouts();

window.HSN.Instance(new HSN.Application
(
    'body',
    '.device-information',
    new HSN.FlyoutManager
    ({
        flyouts: flyouts
    }),
    new HSN.AccountNavigation({
        cabinet: new HSN.AccountNavigation.Cabinet
        ({
            id: 'cabinet',
            drawers:[]
        }),
        container: '#utility-nav',
        drawerParent: '#utility-nav-parent',
        welcome: '#utility-nav-welcome',
        signin: '#utility-nav-signin',
        signout: '#utility-nav-signout',
        account: '#utility-nav-account',
        alert: "#utility-nav-alerts",
        alertCount: "#account-alert-count",
        noajax: noAjax,
        noUpdateState: false,
    }),
    {
        NicknameModal: HSN.NicknameModal,
        VideoModal: HSN.VideoModal,
    }
));

new HSN.AccountNavigation({
    cabinet: new HSN.AccountNavigation.Cabinet
    ({
        id: 'cabinet',
        drawers:
        [
            new HSN.AccountNavigation.Cabinet.Drawer
            ({
                identifier: 'lessman-favorites',
                trigger: '#lessman-favorites-drawer-trigger',
                url: '/account/favorites',
                noajax: noAjax,
                callback: function () {
                    SetFavoriteDrawer();
                },
                closeCallback: function () {
                    CloseFavoriteDrawer();
                }
            })
        ]
    }),
    container: '#utility-nav',
    drawerParent: '#primary-navigation-minified',
    welcome: '#utility-nav-welcome',
    signin: '#utility-nav-signin',
    signout: '#utility-nav-signout',
    account: '#utility-nav-account',
    alert: "#utility-nav-alerts",
    alertCount: "#account-alert-count",
    noajax: noAjax,
    noUpdateState: true
});

HSN.Instance()._getFavoriteService().CheckForFavorites('.favorite-link:not(.favorite-queried)');
HSN.Instance().Events.On(HSN.Application.EVENT.VISITOR_AUTHENTICATED, function () {
    if (Modernizr.sessionstorage) {
        sessionStorage.removeItem("hasCheckedFavorites");
    }
});

jQuery(document).ready(function () {
    var cells = new HSN.ResponsiveCells();
    HSN.OnHomePage();

    //check if users can use cookies- throw a banner article if cookies are disabled.
    if (typeof HsnDrdPageCache !== "undefined") {
        var cookieName = "cookieEnabled";
        HsnDrdPageCache.setCookie(cookieName, "enabled", HsnDrdPageCache.getLowerDomain(), null);
        if (!HsnDrdPageCache.getCookie(cookieName)) {
            HSN.Instance().GetArticleContent({ element: HSN.Instance().Canvas.find('#promo'), appendElement: true }).Show('/article/' + "cookieWarning" + '/' + 100);
        }
        else {
            HsnDrdPageCache.removeCookie(cookieName);
        }
        //Commision Junction - look for cm_mmc parameter and set cookie for 14 days
        var trackCode = HSN.Instance().GetQueryStringParam(window.location.href, 'cm_mmc');
        if (trackCode != null && trackCode.toUpperCase().indexOf('CJ') === 0) {
            HsnDrdPageCache.setCookie('Commision', 'CJ', HsnDrdPageCache.getLowerDomain(), 14);
        }
        else if (trackCode !== '') {
            HsnDrdPageCache.setCookie('Commision', 'OTHER', HsnDrdPageCache.getLowerDomain(), 14);
        }
    }

    HSN.OnAccountStatusLoad(function(data) {
        if (data.displayGlobalPrivacyControlBanner) {
            HSN.Instance().AccountNavigation.Cabinet.Open(new HSN.AccountNavigation.Cabinet.Drawer({ identifier: 'global-privacy-banner', url: '/global-privacy-banner' }));

            setTimeout(function () {
                HSN.Instance().AccountNavigation.Cabinet.Close()
            }, 20000);
        }
    });
});

//Handler for article modals
jQuery('body').on('click', ".article-modal", function (e) {
    articleModalHandler(this, e);
});
jQuery('body').on('keydown', ".article-modal", function (e) {
    var keys = accessibilityUtil.GetKeys();
    if(e.keyCode === keys.enter) {
        articleModalHandler(this, e);
    }
});

function articleModalHandler(scope, e) {
    e.stopPropagation();
    e.preventDefault();

    var articleSlug = jQuery(scope).data("articleSlug");
    var articleId = jQuery(scope).data("articleId");
    if (isNaN(articleId))
        return; //continue
    if (!articleSlug)
        articleId = 'default-article-slug';

    var articleModal = HSN.Instance().GetArticleModal();
    articleModal.SetElementToFocusOnClose(jQuery(scope));
    articleModal.Show('/article/' + articleSlug + '/' + articleId);
      
    HSN.DataLayer.helpers.personalizationEvent($(scope).data("datalayerUdo"));
}

//Handler for content modals
jQuery('body').on('click', ".content-modal", function (e) {
    e.stopPropagation();
    e.preventDefault();

    var contentId = jQuery(this).data("contentId");
    if (isNaN(contentId))
        return true; //continue

    var contentModal = HSN.Instance().GetContentModal();
    contentModal.SetElementToFocusOnClose(jQuery(this));
    contentModal.Show('/content/content/' + contentId);
    return true;
});
  
// Handler for HSN Cares Drive modals
jQuery('body').on('click', ".hsncaresdrivedisclaimer-modal, .rules-link", function (e) {
    e.stopPropagation();
    e.preventDefault();

    cmCreateManualLinkClickTag('/rewards?cm_sp=ArcadeSweeps-_-OfficialRules-_-NA&cm_re=ArcadeSweeps-_-OfficialRules-_-NA', 'ArcadeSweepsRules');

    var disclaimer = jQuery(this).data("disclaimer");
    if (!disclaimer.trim())
        return true;

    HSN.Instance().GetHsnCaresDisclaimerModal().Show(disclaimer);
    return true;
});


//Handler for video modals
jQuery('body').on('click keydown', ".video-modal", function (e) {
    if (e.type === 'keydown' && e.key !== 'Enter') { return; }

    e.stopPropagation();
    e.preventDefault();
    var httpUrl = jQuery(this).attr("data-http-url");
    var analyticCategory = jQuery(this).attr("data-analytic-cat") || jQuery(this).attr('data-category');
    var analyticName = jQuery(this).attr("data-analytic-name") || jQuery(this).attr('data-name');
    var label = jQuery(this).attr("data-label");
    var width = jQuery(this).attr("data-vwidth");
    var height = jQuery(this).attr("data-vheight");
    var customCaptions = jQuery(this).attr("data-custom-captions")
    var hideBranding = jQuery(this).attr("data-hide-branding") ? true : false;

    var vidModal = HSN.Instance().GetVideoModal();
    vidModal.SetElementToFocusOnClose($(e.target).closest('.video-modal'));
    vidModal.Show({ httpUrl: httpUrl, analyticCategory: analyticCategory, analyticName: analyticName, customCaptions: customCaptions }, width, height, false, hideBranding);
    vidModal.Close.focus();
});

//Handler for youtube content videos
jQuery('body').on('click', ".youtube-player-inline, .youtube-player-modal", function () {
    var name = $(this).attr("data-name");
    var category = $(this).attr("data-category");
    var videoId = $(this).attr("data-id");
    var element = $(this).attr("data-element");
    var showDisclaimer = $(this).attr("data-show-disclaimer");
    var label = $(this).attr("data-label");
    var playerRequestedFromPdP = $(this).attr("data-inline-video");
    var settings = {
        type: 'youtube',
        videoId: videoId,
        element: element,
        name: name,
        category: category,
        label: label,
        playerVars: {
            autoplay: $(this).attr("data-autoplay"),
            controls: 1,
            fs: 1,
            theme: "light",
            rel: 0
        }
    };

    if ($(this).hasClass("youtube-player-inline")) {
        if (playerRequestedFromPdP) {
            //Mute audio:
            var playerEventObject ={
                onReady: function (e) {
                    e.target.mute();
                    e.target.playVideo();
                    $(e.target.h).attr('tabindex', 0);
                }
            }
            settings.events = playerEventObject;

            HSN.Instance().Events.Trigger(Events.Widget.Video.TOGGLE_INLINE_PLAYER, settings);
            return false;
        }

        //allow player to be initalized directly instead of the request from PDP.
        var player = new YoutubePlayer(settings);
    }
    else {
        var modal = HSN.Instance().GetYoutubeModal();
        modal.elementToFocusOnClose =
            (!$(this).attr('tabindex') || $(this).attr('tabindex') === '-1') ? $(this).parent() : $(this);
        //show the modal
        settings.element = "hsn-youtube-player";
        modal.Show(settings, 720, 408, showDisclaimer);
    }
    $('.modal-content-container').focus();
    $('.endOfModal').on('focus', function () {
        $('#closeModal').focus();
    });
    $('#modalPopup').on('focus', function () {
        $('.modal-content-container').focus();
    });
    return false;
});

//arcade/lessman shop hsn button
jQuery('body').on('click', '#ShopAllHSN', function () {
    cmCreateManualLinkClickTag('/Lessman-ShopAllHSN?cm_re=Lessman-_-Header-_-ShopAll&amp;cm_sp=Lessman-_-Header-_-ShopAll', 'Lessman-ShopAllHSN');

    $('#navigation-wrapper').off('mouseleave');
    $("#navigation-wrapper2").slideUp(150, function () {
        $("#navigation-wrapper2").css('display', 'none');

        $("#navigation-wrapper").slideDown(500, function () {
            $("#navigation-wrapper").mouseleave(function () {

                $("#navigation-wrapper").slideUp(250, function () {
                    $("#navigation-wrapper2").slideDown(250, 'linear', function () {
                        $("#navigation-wrapper2").css('display', 'block');
                    });
                });
            });
        });
    });
    return false;
});

jQuery('body').on('click', '.bv-write-review', function (e) {
    e.stopPropagation();
    e.preventDefault();
    var productIdentity = jQuery(this).data('product-id') || jQuery(this).data('webpid');
    if (!productIdentity || productIdentity === 0) {
        return false;
    }
    var writeReviewWidget = new HSN.Widget.WriteReview();
    writeReviewWidget.init({ application : HSN.Instance() });
    writeReviewWidget.execute(productIdentity);
    return false;
});

//--------Begin Search

//Search button
HSN.ProxyButton('#search-submit', 'ir');

//search suggestion flyout
var searchSuggestTimeoutId = 0;
var searchSuggestFlyout =
    new HSN.Flyout({
        cacheable : true,
        closeClass : 'ir',
        flyout : '#search-form .flyout',
        url : '/search/suggest?query=' + encodeURIComponent(jQuery('#search-input').val()),
        noajax : noAjax,
        trigger : '#search-form .flyout',
        enablehover : Modernizr.touchevents,
        triggerEvent : HSN.Flyout.TRIGGER_EVENT.HOVER,
        setMask : true
    });
    //HDO-1622

const searchContainer = document.querySelector('.search-container');
const searchInput = document.getElementById('search-input');

if (searchContainer !== null) {
    searchContainer.addEventListener('click', () => {
        searchInput.focus();
    });
    
    searchContainer.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
            searchInput.focus(); // Focus the input when Enter is pressed on the icon
        }
    });

    if (searchInput !== null) {
        searchInput.addEventListener('blur', () => {
            searchContainer.blur(); // Unfocus the icon when the input loses focus
        })
    }
}
//end
searchSuggestFlyout.Events.On(HSN.Flyout.EVENT.AFTER_LOAD, function (flyoutScope) {
    var isTablet = HSN.Instance().DeviceInformation.IsTablet;

    $('#search-suggestions-v3 .product-name').each(function () {
        $clamp($(this)[0], { clamp: 3, splitOnChars: [''] });
    });

    if (!$('#search-form .slimScrollSearch').length) {
        $('#search-form #search-suggestions-v3').slimScroll({
            wrapperClass: 'slimScrollSearch',
            alwaysVisible: isTablet,
            color: '#999',
            railColor: '#f2f2f2',
            height: '200px',
            size: '11px',
            distance: '4px',
            borderRadius: '0px',
            wheelStep: isTablet ? 40 : 8,
            opacity: 1,
            railOpacity: 1,
            railVisible: true,
            disableFadeOut: true
        });

        if (!isTablet)
            $(".slimScrollSearch .slimScrollBar").hide();
    }

    if (isTablet) {
        $(document)
            .off('touchstart.SearchFlyoutCapture')
            .on('touchstart.SearchFlyoutCapture', function (e) {
                if (!$(e.target).parents('#searchbar-v3').length) {
                    searchSuggestFlyout.Close(null);
                }
            });
    }
}, this);

searchSuggestFlyout.Events.On(HSN.Flyout.EVENT.BEFORE_CLOSE, function (flyoutScope) {
    var isTablet = HSN.Instance().DeviceInformation.IsTablet;

    if (isTablet)
        $(document).off('touchstart.SearchFlyoutCapture');
}, this);

HSN.Instance().FlyoutManager.Add(searchSuggestFlyout);

jQuery('#search-submit').on('click', function() {
    var cmSitePromo = $(this).attr('manual_cm_sp');
    var cmRealEstateTags = $(this).attr('manual_cm_re');
    cmCreateManualLinkClickTag('/search-submit?cm_re=' + cmRealEstateTags + '&amp;cm_sp=' + cmSitePromo, 'SearchGo');
    return true;
})
//Handle flyout load/unload and selection via key
jQuery('#search-input').on('keyup focus', function (event) {
    var keyCode = event.keyCode || event.which;
    var arrowKey = { up: 38, down: 40 };
    var enterKey = 13;
    var androidKey = 229;
    if ((keyCode == arrowKey.up || keyCode == arrowKey.down || keyCode > 111) && keyCode != androidKey) {
        return;
    }

    if (keyCode == enterKey) {
        event.stopPropagation();
        event.preventDefault();
        var currentSelection = jQuery('#search-suggestions-v3 li.selected');
        if (currentSelection.length > 0) {
            var href = currentSelection.find('a').attr('href');
            window.location = href + '&isSuggested=true';
            var cmSitePromo = $(this).attr('manual_cm_sp');
            var cmRealEstateTags = $(this).attr('manual_cm_re');
            cmCreateManualLinkClickTag('/search-submit?cm_re=' + cmRealEstateTags + '&amp;cm_sp=' + cmSitePromo, 'SearchGo');
            return;
        }
    }
   
    var query = jQuery('#search-input').val();

    if (query != '' && query != null && query.length > 2) {
        clearTimeout(searchSuggestTimeoutId);
        searchSuggestTimeoutId = setTimeout(function () {
            searchSuggestFlyout.Url = '/search/suggest?query=' + encodeURIComponent(query);
            searchSuggestFlyout.Open(null, true);
        }, 250);
    }
    else {
        jQuery('#search-form .flyout').hide();
        jQuery('#modal-mask').remove();
    }
});

//handle search suggestion flyout key navigation
jQuery('#search-input').on('keydown', function (event) {
    var search = $('#search-input').val().trim();

    // save last search in local storage
    window.sessionStorage && window.sessionStorage.setItem('_last_search_', search);

    var searchSuggestions = jQuery('#search-suggestions-v3 li:not(.disabled-header)');
    var hasResults = searchSuggestions.length;
    if (!hasResults) {
        return;
    }

    var keyCode = event.keyCode || event.which;
    var arrowKey = { up: 38, down: 40 };
    var enterKey = 13;

    var currentSelection = jQuery('#search-suggestions-v3 li.selected');

    //If has selected item, and pressed enter, ignore default behavior(form submit) to do search on keyup event
    if (currentSelection.length > 0 && keyCode == enterKey) {
        event.stopPropagation();
        event.preventDefault();
    }

    if (keyCode != arrowKey.up && keyCode != arrowKey.down) {
        return;
    }

    var nextSelection = [];
    if (keyCode === arrowKey.down) {
        nextSelection = currentSelection.nextAll('#search-suggestions-v3 li:not(.disabled-header)').first();
        if (nextSelection.length === 0) {
            nextSelection = jQuery('#search-suggestions-v3 li:not(.disabled-header)').first();
        }
    }
    else if (keyCode === arrowKey.up) {
        nextSelection = currentSelection.prevAll('#search-suggestions-v3 li:not(.disabled-header)').first();
        if (nextSelection.length === 0) {
            nextSelection = jQuery('#search-suggestions-v3 li:not(.disabled-header)').last();
        }
    }

    currentSelection.removeClass('selected');
    nextSelection.addClass('selected');
});

//handle suggested search selection via mouse
jQuery('#search-form').on('click', '#search-suggestions-v3 li a', function (event) {  
    var link = jQuery(this).attr('href');

    link += '&isSuggested=true';

    jQuery(this).attr('href', link);//Modify link to include new querystring parameter for search tracking

    var search = $('#search-input').val().trim();
    var suggested = $(this).text().trim();

    HSN.DataLayer.helpers.compassEvent({ 'search_term': search, 'suggested_search': suggested }, true, true);
});

//handle lessman suggested search selection via mouse
jQuery('#lessman-search-suggestions-flyout').on('click', '#lessman-search-suggestions li a', function () {

    var link = jQuery(this).attr('href');

    link += '&isSuggested=true';

    jQuery(this).attr('href', link);//Modify link to include new querystring parameter for search tracking

    var search = $('#search-input').val().trim();
    var suggested = $(this).text().trim();

    HSN.DataLayer.helpers.compassEvent({ 'search_term': search, 'suggested_search': suggested }, true, true);
});

//handle lessman suggested search (ALL HSN.com) selection via mouse
jQuery('#lessman-search-suggestions-flyout').on('click', '#search-suggestions li a', function () {

    var link = jQuery(this).attr('href');

    link += '&isSuggested=true';

    jQuery(this).attr('href', link);//Modify link to include new querystring parameter for search tracking

    var search = $('#search-input').val().trim();
    var suggested = $(this).text().trim();

    HSN.DataLayer.helpers.compassEvent({ 'search_term': search, 'suggested_search': suggested }, true, true);
});

//Logging if search was done, checking querystring for parameters
jQuery(document).ready(function () {
    var query = HSN.Instance().GetQueryStringParam(window.location.search, 'query');

    //is search result, log
    if (query.length > 0) {
        var wasRedirect = HSN.Instance().GetQueryStringParam(window.location.search, 'rid').length > 0;
        var isSuggested = HSN.Instance().GetQueryStringParam(window.location.search, 'isSuggested');

        var numResults;

        var numResultField = jQuery('#template-product-grid[data-total-products]');
        if (numResultField.length > 0) {//if search result page, get num results
            var notInitialPage = HSN.Instance().GetQueryStringParam(window.location.search, 'skip').length > 0;
            if (notInitialPage) {
                return;
            }
            numResults = parseInt(numResultField.data('total-products'));
        } else if (!wasRedirect) {//not search result or redirect, must be single product page
            numResults = 1;
        } else {
            numResults = null;//must be redirect, set as null
        }

        HSN.Instance().LogKeywordSearch(query, numResults, isSuggested.toLowerCase() == "true", wasRedirect);
    }
});
//------End Search





//--------Begin Arcade Search

//Search button
HSN.ProxyButton('#arcade-search-submit', 'ir');

//search suggestion flyout
var arcadeSearchSuggestTimeoutId = 0;
var arcadeSearchSuggestFlyout = new HSN.Flyout({
    cacheable: true,
    closeClass: 'ir',
    flyout: '#arcade-search-form .flyout',
    url: '/search/suggest?query=' + encodeURIComponent(jQuery('#arcade-search-input').val()),
    noajax: noAjax
});

HSN.Instance().FlyoutManager.Add(arcadeSearchSuggestFlyout);

arcadeSearchSuggestFlyout.Events.On(HSN.Flyout.EVENT.AFTER_LOAD, function (flyoutScope) {
    $('#search-suggestions-v3 .product-name').each(function () {
        $clamp($(this)[0], { clamp: 3, splitOnChars: [''] });
    });
}, this);




//Handle flyout load/unload and selection via key
jQuery('#arcade-search-input').on('keyup', function (event) {
    var keyCode = event.keyCode || event.which;
    var arrowKey = { up: 38, down: 40 };
    var enterKey = 13;
    if (keyCode == arrowKey.up || keyCode == arrowKey.down || keyCode > 111) {
        return;
    }

    if (keyCode == enterKey) {
        event.stopPropagation();
        event.preventDefault();
        var currentSelection = jQuery('#arcade-search-suggestions li:not(.title).selected');
        if (currentSelection.length > 0) {
            var href = currentSelection.find('a').attr('href');
            window.location = href + '&isSuggested=true';
            cmCreateManualLinkClickTag('/search-submit?cm_re=header-_-search-_-NA&amp;cm_sp=header-_-search-_-NA', 'SearchGo');
            return;
        }
    }

    var query = jQuery('#arcade-search-input').val();
    if (query != '' && query != null && query.length > 2) {
        clearTimeout(arcadeSearchSuggestTimeoutId);
        arcadeSearchSuggestTimeoutId = setTimeout(function () {
            arcadeSearchSuggestFlyout.Url = '/search/suggest?query=' + encodeURIComponent(query);
            arcadeSearchSuggestFlyout.Open(null, true);
        }, 250);
    }
    else {
        jQuery('#arcade-search-form .flyout').hide();
    }
});

//handle search suggestion flyout key navigation
jQuery('#arcade-search-input').on('keydown', function (event) {
    var arcadeSearchSuggestions = jQuery('#arcade-search-suggestions li:not(.title)');
    var hasResults = arcadeSearchSuggestions.length;
    if (!hasResults) {
        return;
    }

    var keyCode = event.keyCode || event.which;
    var arrowKey = { up: 38, down: 40 };
    var enterKey = 13;

    var currentSelection = jQuery('#arcade-search-suggestions li:not(.title).selected');

    //If has selected item, and pressed enter, ignore default behavior(form submit) to do search on keyup event
    if (currentSelection.length > 0 && keyCode == enterKey) {
        event.stopPropagation();
        event.preventDefault();
    }

    if (keyCode != arrowKey.up && keyCode != arrowKey.down) {
        return;
    }

    var nextSelection = [];
    if (keyCode == arrowKey.down) {
        nextSelection = currentSelection.nextAll('#arcade-search-suggestions li:not(.title)').first();
        if (nextSelection.length === 0) {
            nextSelection = jQuery('#arcade-search-suggestions li:not(.title)').first();
        }
    }
    else if (keyCode == arrowKey.up) {
        nextSelection = currentSelection.prevAll('#arcade-search-suggestions li:not(.title)').first();
        if (nextSelection.length === 0) {
            nextSelection = jQuery('#arcade-search-suggestions li:not(.title)').last();
        }
    }

    currentSelection.removeClass('selected');
    nextSelection.addClass('selected');
});

//handle suggested search selection via mouse
jQuery('#arcade-search-form').on('click', '#arcade-search-suggestions li a', function (event) {

    var link = jQuery(this).attr('href');

    link += '&isSuggested=true';

    jQuery(this).attr('href', link);//Modify link to include new querystring parameter for search tracking
});
//------End Arcade Search

//jquery placeholder library
jQuery('input, textarea').placeholder();

//w3c markup validation control
jQuery('#markup-validation a').on('click', function (event) {
    event.stopPropagation();
    event.preventDefault();
    jQuery(this).html('Validating...');
    jQuery.ajax(
        '/validation',
        {
            context: this,
            data: { url: window.location.href },
            dataType: 'html',
            type: 'GET',
            success: function (data) {
                jQuery(this).parent().html(data);
            }
        }
    );
});

function SetFavoriteDrawer() {
    jQuery('.favorites-drawer .items-drawer-content .product .supplementary').equalHeights();
    jQuery('.favorites-drawer .items-drawer-content .drawer-content, .favorites-drawer .more-drawer-content .drawer-content').equalHeights();
}

function CloseFavoriteDrawer() {
    jQuery('.favorites-drawer .favorite-wrapper').each(function () {
        var favoriteWidgetName = jQuery(this).attr('id');
        var favoriteWidget = window[favoriteWidgetName];
        if (favoriteWidget && favoriteWidget.destroy) {
            favoriteWidget.destroy();
        }
    });
}

function BuildFlyouts() {
    var flyouts = [];

    flyouts.push(new HSN.Flyout({
        cacheable: true,
        closeClass: 'ir',
        flyout: '#recently-aired .flyout',
        trigger: '#recently-aired',
        url: '/headerfooter/recently-aired',
        noajax: noAjax,
        disableHover: Modernizr.touchevents,
        triggerEvent: Modernizr.touchevents ? HSN.Flyout.TRIGGER_EVENT.CLICK : HSN.Flyout.TRIGGER_EVENT.HOVER
    }));

    jQuery('#lessman-flyout-area > div').each(function () {

        var linkElement = jQuery(this);
        var flyoutElement = jQuery(this).children('div');

        if (flyoutElement.length > 0) {
            var flyout = new HSN.Flyout({
                cacheable: true,
                closeClass: 'ir',
                closeTag: 'li',
                flyout: flyoutElement,
                trigger: this,
                url: '/namedcell?name=' + linkElement.attr('data-marketing-id'),
                noajax: noAjax,
                disableHover: Modernizr.touchevents,
                triggerEvent: HSN.Flyout.TRIGGER_EVENT.CLICKHOVER

            });

            flyouts.push(flyout);
        }
    });

    if ($('#arcade.arcade').length > 0)
        flyouts.push(new HSN.Flyout({
            cacheable: true,
            closeClass: 'ir',
            flyout: '#arcade.arcade .flyout',
            trigger: '#arcade.arcade',
            url: '/namedcell?name=Arcade-Flyout',
            noajax: noAjax,
            disableHover: Modernizr.touchevents,
            triggerEvent: Modernizr.touchevents ? HSN.Flyout.TRIGGER_EVENT.CLICK : HSN.Flyout.TRIGGER_EVENT.HOVER
        }));

    jQuery(document).ready(function () {
        var accountMenu = new HSN.AccountMenu();
        accountMenu.init({
            application : HSN.Instance(),
            container: '#account-dropdown',
            noAjax: noAjax
        });
        //email signup footer
        if ($('.email-signup-container').length > 0) {
            var emailSignup = new HSN.EmailSignUp();
            emailSignup.init({
                application: HSN.Instance(),
                container: '.email-signup-container',
                submitElement: '.email-signup-submit-btn',
                errorElement: '#signup-email-errors',
                errorConfirmElement: '#signup-confirm-email-errors'
            });
        }        
        
        jQuery('#hamburger-open-button').one('mouseenter', function () {
            var flyout = new HSN.HamburgerFlyout({
                application: HSN.Instance(),
                flyout: jQuery("#hamburger-holder"),
                trigger: jQuery("#hamburger-holder").add(this)
            });

            flyout.OpenHamburgerMenu();
        });        
    });
    jQuery(window).on("load", function() {
        if ($('#shopping-bag-flyout').length > 0 && !noAjax) {
            HSN.Instance().SetBagFlyout(new HSN.BagFlyout({
                trigger: '#shopping-bag-flyout',
                flyout: '#shopping-bag-flyout .flyout',
                flyoutContent: '#shopping-bag-flyout .flyout .bag-container',
                application: HSN.Instance()
            }));
        }
    });
    jQuery(document).ready(function () {
        $('#search-form form').submit(function (e) {
            var search = $('#search-input').val().trim();

            HSN.DataLayer.helpers.compassEvent({ 'search_term': search }, true, true);

            // Relies on the event above setting 'search_term'
            HSN.DataLayer.helpers.hsnEvent(null, 'SearchSubmit', 'Success');
        });
    });

    //Support for new floaty input labels
    jQuery(document).ready(function () {
        var inputWidget = new HSN.Widget.FancyInput();
        inputWidget.init({
            application: HSN.Instance()
        });
    });

    return flyouts;
}



// WEBPACK FOOTER //
// ./assets/js/initializer.js